import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  loadingBoxCertified: {
    height: 20,
    width: 130,
  },
  loadingHighestAchievedRank: {
    height: 20,
    width: 100,
  },
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItemContainer: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
});
